import Account from "@/helper/AccountHelper.js";

const Flag32 = 32; // 100000000000000000000000000000000 index 32

export function UserLevel() {
    this.userLevel = Account.getUserLevelDetail();
    this.userLevel = this.userLevel.split("").reverse().join("");

    this.isFlag32 = function () {
        let rs = this.userLevel[Flag32];
        return rs === '1';
    };

}
